import React, { useState } from "react";
import { api } from "../lib/kk";
import { toast } from "sonner";

export const DepositButton = ({ packageId, label, className = "", children, name = "", email = "", note = true }) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async () => {
    setLoading(true);
    try {
      const origin = window.location.origin;
      const { data } = await api.post("/payments/checkout/session", {
        package_id: packageId,
        origin_url: origin,
        name,
        email,
      });
      if (data.url) {
        window.location.href = data.url;
      } else {
        throw new Error("No checkout URL");
      }
    } catch (e) {
      toast.error("Unable to start payment. Please try again.");
      setLoading(false);
    }
  };

  return (
    <>
      <button
        onClick={handleClick}
        disabled={loading}
        data-testid={`deposit-btn-${packageId}`}
        className={`kk-btn kk-btn-primary rounded-full px-8 py-4 disabled:opacity-60 ${className}`}
      >
        {loading ? "Redirecting…" : children || label}
      </button>
      {note && (
        <p className="text-[#999999] text-xs text-center mt-3" data-testid="bnpl-note">
          Secure checkout by Stripe · Pay in 4 with <span className="text-[#E0E0E0] font-semibold">Klarna</span> or <span className="text-[#E0E0E0] font-semibold">Afterpay</span> available
        </p>
      )}
    </>
  );
};

export default DepositButton;
